const carouselItems = [
  {
    id: 'music',
    title: '热门音乐综艺',
    desc: '集结最火音乐竞技与创作节目，感受舞台魅力的极致碰撞',
    icon: 'ri-music-2-fill',
    img: 'https://readdy.ai/api/search-image?query=music%20variety%20show%20stage%20with%20dramatic%20spotlight%20and%20warm%20golden%20amber%20lighting%2C%20professional%20studio%20setting%20with%20microphone%20and%20instruments%2C%20cinematic%20entertainment%20photography%2C%20dark%20background%20with%20light%20beams%2C%20elegant%20composition&width=800&height=500&seq=carousel-music&orientation=landscape',
  },
  {
    id: 'outdoor',
    title: '户外真人秀精选',
    desc: '探险、挑战、旅行一网打尽，跟随镜头走遍山川湖海',
    icon: 'ri-compass-3-fill',
    img: 'https://readdy.ai/api/search-image?query=outdoor%20adventure%20reality%20show%20scene%20with%20natural%20landscape%20and%20warm%20sunlight%2C%20group%20of%20people%20exploring%20nature%2C%20cinematic%20wide%20shot%20with%20golden%20hour%20lighting%2C%20travel%20and%20challenge%20theme%2C%20clean%20editorial%20style&width=800&height=500&seq=carousel-outdoor&orientation=landscape',
  },
  {
    id: 'talk',
    title: '脱口秀专场',
    desc: '笑料不断，精彩不停，汇集最犀利的段子和最有趣的灵魂',
    icon: 'ri-emotion-laugh-fill',
    img: 'https://readdy.ai/api/search-image?query=comedy%20talk%20show%20stage%20with%20warm%20spotlight%20and%20microphone%20stand%2C%20stand-up%20comedy%20atmosphere%2C%20brick%20wall%20background%20with%20dramatic%20lighting%2C%20entertainment%20venue%20setting%2C%20golden%20amber%20tones%2C%20editorial%20photography&width=800&height=500&seq=carousel-talk&orientation=landscape',
  },
  {
    id: 'talent',
    title: '选秀与才艺',
    desc: '见证明日之星的诞生，感受才华与梦想的闪耀时刻',
    icon: 'ri-star-fill',
    img: 'https://readdy.ai/api/search-image?query=talent%20show%20stage%20with%20dramatic%20spotlights%20and%20golden%20confetti%2C%20performance%20competition%20atmosphere%2C%20grand%20stage%20design%20with%20warm%20lighting%2C%20entertainment%20show%20production%2C%20cinematic%20wide%20angle%2C%20editorial%20style&width=800&height=500&seq=carousel-talent&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            每日精选热门综艺专题，总有一档适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all hover:ring-2 hover:ring-primary-300/50"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={`极速影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center">
                    <i className={`${item.icon} text-background-50 text-sm`}></i>
                  </div>
                  <span className="text-background-50 text-sm font-bold">{item.title}</span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}